import { render } from "./StoryList.vue?vue&type=template&id=65ab9183&scoped=true"
import script from "./StoryList.vue?vue&type=script&lang=ts"
export * from "./StoryList.vue?vue&type=script&lang=ts"

import "./StoryList.vue?vue&type=style&index=0&id=65ab9183&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-65ab9183"

export default script
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTr,QTh,QTd,QToggle,QChip,QBtn,QMenu,QList,QItem,QItemSection,QIcon,QSpace,QDialog});qInstall(script, 'directives', {ClosePopup});
